<template>
	<div>
		<table class="data table additional-attributes" id="product-attribute-specs-table">
			<tbody>
			<tr v-for="item in data">
				<th class="col label" scope="row">{{item.key}}</th>
				<td class="col data" data-th="Brand">{{item.value}}</td>
			</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: "KeyValueTable",
	props : ['data']
}
</script>

<style scoped>

</style>